import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoutLoadingService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoadingSubject.asObservable();

  constructor() { }

  setLoading(isLoading: boolean): void {
    this.isLoadingSubject.next(isLoading);
  }

  get isLoading(): boolean {
    return this.isLoadingSubject.value;
  }
}

